import React from 'react';
import { connect } from 'react-redux';

import WizardForm from './Wizard/WizardForm';
import NavBar from '../presentational/Utils/Navbar';
import { saveUserData } from '../../redux/actions';

const ApplyContainer = (props) => {
	const sendData = (values) => {
		props.saveUserData(values);
	};

	return (
		<>
			<NavBar />
			<WizardForm onSubmit={sendData} />
		</>
	);
};

const mapDispatchToProps = {
	saveUserData,
};

export default connect(
	null,
	mapDispatchToProps,
)(ApplyContainer);
